import React, { Fragment } from 'react'

import { DateTimePickerUTC } from '../../../UI/DateTimePickerUTC/DateTimePickerUTC'

import { DateTime } from 'luxon'
import { Box, Grid } from '@mui/material'

interface DateRangeFilterProps {
  handleSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  initialDate: DateTime | null
  finalDate: DateTime | null
  isValid: boolean
  isShowed: boolean
  variant?: 'outlined' | 'filled' | 'standard'
}

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  handleSearch,
  initialDate,
  finalDate,
  isValid = true,
  isShowed = true,
  variant = 'standard'
}) => {
  return (
    <Fragment>
      <Grid item xs={12} sm={6}>
        <Box
          display={!isShowed ? 'none' : 'flex'}
          justifyContent='center'
          alignItems='center'
          minHeight='1vh'
        >
          <DateTimePickerUTC
            error={!isValid}
            handleUTCSelectedDateTimeChange={handleSearch}
            label='Desde'
            name='initialDate'
            initialUTCSelectedDateTime={initialDate}
            showLocal
            variant={variant}
          />
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box
          display={!isShowed ? 'none' : 'flex'}
          justifyContent='center'
          alignItems='center'
          minHeight='1vh'
        >
          <DateTimePickerUTC
            error={!isValid}
            handleUTCSelectedDateTimeChange={handleSearch}
            label='Hasta'
            name='finalDate'
            initialUTCSelectedDateTime={finalDate}
            showLocal
            variant={variant}
          />
        </Box>
      </Grid>
    </Fragment>
  )
}
